import { Box } from "@mui/material";
import TextWithExternalLink from "../../components/ExternalLink";

/**
 * Demo component for TextWithExternalLink
 * Shows the external link component with different text and link configurations
 */
const ExternalLinkDemo = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <TextWithExternalLink
        text="Learn more about our platform at"
        linkText="our website"
        href="https://example.com"
      />

      <TextWithExternalLink
        text="Check out our documentation at"
        linkText="docs.example.com"
        href="https://docs.example.com"
        tooltipText="Some tooltip text for this specific link!"
      />

      <TextWithExternalLink
        text="For support, visit"
        linkText="support portal"
        href="https://support.example.com"
        linkColor="red"
      />
    </Box>
  );
};

export default ExternalLinkDemo;
